
import React from 'react';
import { Direction } from './types';

const MobileControls = ({ onDirectionChange }) => {
    const handleTouch = (direction) => {
        onDirectionChange(direction);
    };

    return (
        <div className="fixed bottom-8 right-8 z-20 lg:hidden">
            <div className="grid grid-cols-3 grid-rows-3 w-48 h-48">
                <div className="col-start-2 row-start-1 flex justify-center items-center">
                    <button onTouchStart={() => handleTouch(Direction.UP)} className="w-16 h-16 bg-gray-700/50 rounded-full text-white text-2xl active:bg-cyan-500/50">▲</button>
                </div>
                <div className="col-start-1 row-start-2 flex justify-center items-center">
                    <button onTouchStart={() => handleTouch(Direction.LEFT)} className="w-16 h-16 bg-gray-700/50 rounded-full text-white text-2xl active:bg-cyan-500/50">◀</button>
                </div>
                <div className="col-start-3 row-start-2 flex justify-center items-center">
                    <button onTouchStart={() => handleTouch(Direction.RIGHT)} className="w-16 h-16 bg-gray-700/50 rounded-full text-white text-2xl active:bg-cyan-500/50">▶</button>
                </div>
                <div className="col-start-2 row-start-3 flex justify-center items-center">
                    <button onTouchStart={() => handleTouch(Direction.DOWN)} className="w-16 h-16 bg-gray-700/50 rounded-full text-white text-2xl active:bg-cyan-500/50">▼</button>
                </div>
            </div>
        </div>
    );
};

export default MobileControls;
